import React from "react";
import Image from "components/image";
import  { StyledTextWithNumbers }  from "components/text-formatter";

const SecureCheckout = ({ data }) => (
	<div className="flex flex-col items-center horizontal-padding">
		{data.title &&
			<h2 className="text-white text-center font-bold pt-12 md:pt-0">
				<StyledTextWithNumbers text = {data.title} />
			</h2>
		}
		<div className="w-full flex gap-x-0 gap-y-4 md:gap-8 justify-center flex-wrap py-12 md:pb-0">
			{data.items.map((item, index) => (
				<div key={index}
					className="flex flex-col max-w-40 md:max-w-48 justify-start">
					{item?.icon &&
						<div className="mx-auto w-14">
							<Image image={item.icon} />
						</div>
					}
					{item?.text &&
						<div className="flex flex-col items-center justify-center text-center pt-4">
							<p className="text-white font-semibold text-xs sm:text-base px-3">{item.text}</p>
						</div>
					}
				</div>
			))}
		</div>
	</div>
);

export default SecureCheckout;